<template>
	<div class="member-list-row"
		v-bind:class="classMemberListRow"
		v-on:click.stop="onClickSelectMember"
	>
		<div class="member-list-row-inner"  v-bind:style="styleInner">
			<div class="member-list-row-content d-flex pl-2">
				<div style="width: 100%;" v-if="this.item">
					<div class="name">{{ this.item.name }}</div>
					<div class="classes">
						<Classes
							:items=this.item.classes
							:max_width=278
							:all_show=false
							:is_show_icon=true
						/>
					</div>
					<div class="comment small-font">
						<template>
							<v-icon class="blue--text comment-icon">message</v-icon>
							<div class="comment-body">{{ this.item.comment }} </div>
						</template>
					</div>
					<template v-if="this.filtered_taks != undefined && this.filtered_taks.length > 0">
						<v-layout row>
							<v-flex xs10>
								<div class="taskinfo small-font" v-bind:style="styleScheduleFont(filtered_taks[0].schedules[0])">
									<span class="mr-2">
										{{ displaySchedule(filtered_taks[0].schedules[0]) }}
									</span>
									<span>
										{{ filtered_taks[0].name }}{{ dispProjectName(filtered_taks[0].project_code) }}
									</span>
								</div>
							</v-flex>
							<v-flex xs2>
								<div class="small-font" v-bind:style="styleScheduleFont(filtered_taks[0].schedules[0])">
									<span v-if="this.filtered_taks.length >1" class="ml-2"> 他 {{ this.filtered_taks.length -1}}件</span>
								</div>
							</v-flex>
						</v-layout>
					</template>
					<template v-else>
						<div class="taskinfo small-font" >予定が入っていません</div>
					</template>
				</div>
			</div>
			<template v-if="isSelectMode">
				<div class="member-list-row-action login-user-btn-layout d-flex">
					<template fab flat class="btn-slide" v-if="isSelected">
						<v-icon>check</v-icon>
					</template>
					<v-btn fab flat class="btn-slide login-user-btn" v-on:click.stop="toggleSlideLeft" v-if="isLoginUser && isTList"><v-icon>more_horiz</v-icon></v-btn>
				</div>
				<template v-if="isLoginUser && isTList">
					<div class="member-list-row-right d-flex">
						<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowMemberInfo">編集</v-btn>
					</div>
				</template>
			</template>
			<template v-else>
				<div class="member-list-row-action d-flex">
					<v-btn  fab flat class="btn-slide" v-on:click.stop="toggleSlideLeft"><v-icon>more_horiz</v-icon></v-btn>
				</div>
				<div class="member-list-row-right d-flex">
					<template v-if="$store.getters['chart/isEditable']">
						<v-btn depressed color="info" v-on:click.stop="onClickRowMoveStart">
							<v-icon>swap_vert</v-icon>
						</v-btn>
						<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowMemberInfo">編集</v-btn>
					</template>
					<template v-else>
						<v-btn depressed color="info" class="btn-show" v-on:click.stop="onShowMemberInfo">参照</v-btn>
					</template>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import Classes from './Classes';

import {SLIDE, LIST_MODE} from '../classes/Const';

export default {
	name: 'RightPaneMemberListRow',
	props: [
		'item',
		'isSelected',
		'isLoginUser',
		'mode',
		"watchSlide",
	],
	components: {
		Classes,
	},
	data: function() {
		return {
			slide_status: SLIDE.STATUS.CENTER,
		};
	},
	methods: {
		toggleSlide: function(direction) {
			if (this.slide_status === direction)
				this.slide_status = SLIDE.STATUS.CENTER;
			else {
				this.slide_status = direction;
				this.$emit('member-list-row-slide', {target: this.item, status: this.slide_status});
			}
		},
		toggleSlideLeft: function() {
			this.toggleSlide(SLIDE.STATUS.LEFT);
		},
		onShowMemberInfo: function() {
			let member = this.$store.getters.member(this.item.code);
			this.$emit("show-member-info", member);
		},
		onClickSelectMember: function() {
			this.$emit('member-selected', this.item.code);
		},
		onClickRowMoveStart: function(){
			return false;
		},
		displaySchedule: function(schedule) {
			if (typeof schedule == 'undefined')
				return text;
				
			let text = '';
			let day = new Date();
			let next_day = new Date(day.getTime());
			next_day.setDate(next_day.getDate() + 1);

			if (schedule.all_day) {
				text = "終日";
			} else if (schedule.begin.isFirstTick(day) && schedule.end.isFirstTick(next_day)) {
				text = "終日";
			} else if (schedule.begin.isBeforeDay(day)
					&& (schedule.end.isAfterDay(day) || (schedule.end.isFirstTick(next_day)))) {
	
				text = "終日";
			} else {
				 if (!schedule.begin.isBeforeDay(day)){
						
					text += schedule.begin.strftimeDCL('%H:%M');
				}
				text += " ～ "
				if (!schedule.end.isAfterDay(day)){
					text += schedule.end.strftimeDCL('%H:%M');
				}
			}
			return text;
		},
		dispProjectName: function(code){
			if(code === '')
				return '';
			let item = this.$store.getters['project'](code);
			if (item){
				return '@' + this.$store.getters['project'](code).name;
			}
				return '';
		},
		checkDisplaySchedule: function(schedule, day){
			if (schedule.all_day) {
				return schedule.isOverlapOneDay(day);
			} else {
				return schedule.isContainsDateTime(day);
			}
		},
	},
	computed: {
		styleInner: function() {
			let left = 0;
			if (this.slide_status == SLIDE.STATUS.LEFT) {
				if (this.mode == LIST_MODE.SELECT){
					left = -60;
				}else if (!this.$store.getters['chart/isEditable']){
					left =  -60;
				}else{
					left =  -120;
				}
			}
			return {
				left: left + 'px',
				transition: 'all .3s ease-in',
			};
		},
		filtered_taks: function() {
			let tasks = this.$store.getters['dataTask'];
			tasks = tasks.filter(t => t.member_code == this.item.code);

			if(tasks.length > 0 ){
				let day = new Date();

				tasks = tasks.filter( t => {
					let match = t.schedules.filter( s=> (this.checkDisplaySchedule(s, day)))[0];
					return t.schedules.findIndex(item => item === match ) >= 0;
				});
				tasks.map(t => t.schedules.filter( s=> (this.checkDisplaySchedule(s, day))));
				return tasks;
			
			}
			return tasks;
		},
		classMemberListRow: function() {
			let classes = new Array();
			if (this.$route.name === 'GanttTimeBoardList' && this.isLoginUser ){
				classes.push("login-user");
			}
			if (this.mode == LIST_MODE.SELECT ){
				classes.push("selectable");
			}
			return classes;
		},
		isTChart: function() {
			return this.$route.name == 'GanttTimeBoardChart';
		},
		isTList: function() {
			return this.$route.name == 'GanttTimeBoardList';
		},
		isSelectMode: function(){
			if(this.mode == LIST_MODE.SELECT){
				return true;
			} else {
				return false;
			}			
		},
		styleScheduleFont: function () {
			return function (schedule) {
				if (schedule.isAssociatedProject){
					return {
						"color": "mediumaquamarine"
					};
				} else if(schedule.isTaskSchedule){
					return {
						"color": "mediumpurple"
					};
				}
			};
		},
	},
	watch: {
		watchSlide: function(value) {
			if (value.type === 'slide' && value.target === this.item)
				return;
			if (this.slide_status !== SLIDE.STATUS.CENTER)
				this.slide_status = SLIDE.STATUS.CENTER;
		},
	},
};
</script>
<style>
	.member-list-row {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		height: 90px;
		background-color: #fefefe;
		border-bottom: solid 1px #a9a9a9;
	}
	.member-list-row-inner {
		display: flex;
		position: relative;
		width: 470px;
	}
	.member-list-row-content {
		padding: .25em;
		width: 294px;
	}
	.member-list-row-content .taskinfo{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 235px;
	}
	.member-list-row-content .name {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100%;
		max-width: 278.5px;
		height: 1.2em;
		font-size: 13px;
	}
	.member-list-row-content .comment-body{
		padding-left: 1.6em;
		word-wrap:break-word;
	}
	.member-list-row-content .comment-icon{
		position: absolute;
		font-size: 14px;
		top: 2px;
	}
	.member-list-row-content .small-font{
		font-size: 10px;
	}
	.member-list-row-content .comment{
		min-height: 32px;
		position: relative;
	}
	.member-list-row .login-user-btn.v-btn{
		height: 40% !important;
		position: absolute !important;
		min-width: 60px !important;
	}
	.member-list-row-action {
		position: relative;
		min-width: 60px;
	}
	.login-user-btn-layout .btn-slide {
		position: relative;
		min-width: 56px !important;
	}
	.member-list-row-action .btn-slide {
		min-width: 36px !important;
	}
	.member-list-row-right div {
		width: 16px;
	}
	.member-list-row.login-user {
		background-color: #D9E5FF;
	}
	.member-list-row.selectable{
		cursor: pointer;
	}
	.member-list-row.selectable:hover{
		background-color: #EFEFEF;
	}
</style>
<style scoped>
	.member-list-row .v-btn {
		margin: 0;
		padding: 0;
		min-width: 60px;
		height: 100%;
		border-radius: 0;
		font-size: .75em;
	}
</style>
